import { path, pathOr } from 'ramda'

export const getFacilityName = facilities => pathOr('', ['0', 'facilityName'], facilities)

export const getFacilityAddress = (facilities) => {
  const city = path(['0', 'city'], facilities)
  const state = path(['0', 'state'], facilities)
  if (city && state) {
    return `${city}, ${state}`
  }
  return ''
}
